var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredentialsCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2002 19.5C62.6002 21.9 62.6002 25.8 60.2002 27.9L51.8002 36.3L28.4002 12.9L36.8002 4.50002C39.2002 2.10002 43.1002 2.10002 45.2002 4.50002L50.6002 9.90003L59.6002 0.900024L63.8002 5.10002L54.8002 14.1L60.2002 19.5ZM42.8002 36.9L38.6002 32.7L30.2002 41.1L23.9002 34.8L32.3002 26.4L28.1002 22.2L19.7002 30.6L15.2002 26.4L6.80019 34.8C4.40019 37.2 4.40019 41.1 6.80019 43.2L12.2002 48.6L0.200195 60.6L4.4002 64.8L16.4002 52.8L21.8002 58.2C24.2002 60.6 28.1002 60.6 30.2002 58.2L38.6002 49.8L34.4002 45.6L42.8002 36.9Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialsCreate);
export default __webpack_public_path__ + "static/media/credentialsCreate.87b82dc510c66871927ac2cc426d7104.svg";
export { ForwardRef as ReactComponent };